import {
    Background,
    Card,
    CardWrapper,
    FloatingSquareImage,
    HeaderWrapper,
    MainContainer,
} from '../components/services'
import blueLine from '../assets/images/blue-line1.png'
import { Header20, Header48, Header64, Paragraph16, SubHeader16, SubHeader32 } from '../styles/typography'
import card1 from '../assets/images/services/framing.png'
import card2 from '../assets/images/card-2.png'
import card3 from '../assets/images/card-3.png'
import card4 from '../assets/images/testimonial-image.jpg'
import { BlueButton } from '../components/atoms/button'
import blueBox from '../assets/images/blue-box2.png'
import { projects } from '../projects'
import { SimpleLink } from '../components/atoms/link'

export function Services() {
    return (
        <>
            <Background>
                <MainContainer>
                    <FloatingSquareImage src={blueBox} />
                    <HeaderWrapper>
                        <div style={{ display: 'flex', flexDirection: 'row', gap: '12px', alignItems: 'center' }}>
                            <img style={{ height: '4px', width: '40px' }} src={blueLine} />
                            <SubHeader32 style={{ color: '#4E7BBC' }}>What We Do</SubHeader32>
                        </div>
                        <h2>Our Services</h2>
                        <Paragraph16 style={{ color: '#63665B', textAlign: 'justify' }}>
                            From structure to finish, we provide dependable construction services tailored to your
                            specific needs. Our commitment to craftsmanship and attention to detail means you can trust
                            Fine Line Construction to bring your vision to life.
                        </Paragraph16>
                    </HeaderWrapper>
                    <CardWrapper>
                        {projects.slice(0, 4).map((project, index) => (
                            <Card key={index} to={`/${project.id}`}>
                                <img style={{ width: '100%', height: '212px', objectFit: 'cover' }} src={project.img} />
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                    <h3>{project.title}</h3>
                                    <Paragraph16>{project.details}</Paragraph16>
                                </div>
                            </Card>
                        ))}
                    </CardWrapper>
                    <div style={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
                        <SimpleLink to='/services'>
                            <BlueButton style={{ width: '180px' }}>
                                <SubHeader16>More Services</SubHeader16>
                            </BlueButton>
                        </SimpleLink>
                    </div>
                </MainContainer>
            </Background>
        </>
    )
}
